import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c8f221d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "future-trips" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Kommende ture", -1))
const _hoisted_3 = {
  key: 0,
  class: "trip-grid"
}
const _hoisted_4 = {
  key: 1,
  class: "empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TripTile = _resolveComponent("TripTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.futureTrips.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.futureTrips, (trip) => {
            return (_openBlock(), _createBlock(_component_TripTile, {
              key: trip.year,
              trip: trip
            }, null, 8, ["trip"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "Ingen kommende ture er planlagt endnu."))
  ]))
}